import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '14';
const IABid = [28];

export const createPixel = (consentData?: string | null): HTMLImageElement => {
  const img = document.createElement('img');
  img.style.display = 'none';
  if (consentData) {
    img.src = `https://eb2.3lift.com/getuid?gdpr=1&gdpr_consent=${consentData}&redir=${getUserSyncURL(
      ID,
    )}%24UID`;
  } else {
    img.src = `https://eb2.3lift.com/getuid?gdpr=0&gdpr_consent=&redir=${getUserSyncURL(ID)}%24UID`;
  }

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (context.gdprConsent.consent?.gdprApplies) {
      const img = createPixel(context.gdprConsent.consent.tcString);
      fastdom.mutate(function userSyncTripleliftCMPAddElement() {
        document.body.appendChild(img);
      });
    } else {
      const img = createPixel();
      fastdom.mutate(function userSyncTripleliftAddElement() {
        document.body.appendChild(img);
      });
    }
  }),
);
